import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveResourceFromProjectNotificationState = createStateReducer(
  initialState,
  {
    [events.removeResourceFromProjectSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceFromProject",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeResourceFromProjectFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceFromProject",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceRemoveResourceFromProjectNotificationState };
